import { GuiController } from '../controllers/GuiController';
import { RouletteController } from '../controllers/RouletteController';
import { StateController } from '../controllers/StateController';
import { GameOverState } from '../states/GameOverState';
import { IddleState } from '../states/IddleState';
import { BetManager } from '../ui/BetManager';
import { ChipInfo, ChipManager } from '../ui/ChipManager';
import { HistoryManager } from '../ui/HistoryManager';
import { NotificationManager } from '../ui/NotificationManager';
import { NumberAreaManager } from '../ui/NumberAreaManager';
import { Roulette } from '../ui/Roulette';
import { SceneButton } from '../ui/SceneButton';
import { WebSocketManager } from '../ui/WebSocketManager';
import { GameConfig } from '../utils/GameConfig';
import { ResetManager } from '../utils/resetManager';
import { undoLastBet } from '../utils/undoManager';

function getQueryParam(param: string): string | null {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param);
}

export interface BetEntry {
	type: 'straight' | 'color' | 'oddEven' | 'dozen' | 'column' | 'highLow' | 'range';
	target: string;
	numbers: number[];
	amount: number;
}

export class RouletteScene extends Phaser.Scene {
	private gameWidth: any;
	private gameHeight: any;
	private centerX: any;
	private centerY: any;

	private roulette!: Roulette;
	private chipManager!: ChipManager;
	private numberAreaManager!: NumberAreaManager;
	private betManager!: BetManager;
	private resetManager!: ResetManager;
	private notificationManager!: NotificationManager;

	public history: {
		numberArea: string;
		valuesBefore: number[];
		valuesAfter: number[];
		chip: Phaser.GameObjects.Container;
		coinValue: number;
		balanceBefore: number;
		balanceAfter: number;
		betBefore: number;
		betAfter: number;
		betsSnapshotBefore: BetEntry[];
		betsSnapshotAfter: BetEntry[];
	}[] = [];
	public chips: Phaser.GameObjects.Container[] = [];
	public placedChipsMap: Map<string, Phaser.GameObjects.Container> = new Map();
	public rouletteID: string = '';
	public rouletteIDUI!: Phaser.GameObjects.Text;
	public rouletteScore!: Phaser.GameObjects.Text;
	public rouletteBalance!: Phaser.GameObjects.Text;
	public rouletteBalanceValue: number = 0;
	public rouletteMaxBet!: Phaser.GameObjects.Text;
	public rouletteMaxBetValue: number = 0;
	public rouletteBet!: Phaser.GameObjects.Text;
	public rouletteBetValue: number = 0;
	public previousBalanceBeforeSpin: number = 0;
	public score: number = 0;
	public rouletteSound!: Phaser.Sound.BaseSound;

	private stateController!: StateController;
	private guiController!: GuiController;
	private rouletteController!: RouletteController;

	private iddleState!: IddleState;
	private gameOverState!: GameOverState;

	private pr: number = 0;
	private inProgress: boolean = false;
	private historyManager!: HistoryManager;

	constructor() {
		super({ key: 'RouletteScene' });
		this.rouletteID = '';
	}

	create() {
		// 1) Centers
		this.gameWidth = this.game.config.width;
		this.gameHeight = this.game.config.height;
		this.centerX = this.gameWidth / 2 + GameConfig.boardOffSetX;
		this.centerY = this.gameHeight / 2 + GameConfig.boardOffSetY;

		if (this.cache.audio.exists('rouletteSound')) {
			this.rouletteSound = this.sound.add('rouletteSound');
		} else {
			console.error('Som não encontrado no cache!');
		}

		// UI
		this.startWebsocket();
		this.initValues();
		this.createUI();
		this.startClasses();
		this.createButtons();

		// History
		const historyContainer = this.add.container(this.centerX + 165, this.centerY - 460);
		this.historyManager = new HistoryManager(this, historyContainer, GameConfig.blacks, GameConfig.reds);
	}

	handleWebSocketAction(action: string, payload: any) {
		switch (action) {
			case 'setRouletteID':
				this.rouletteID = payload.id;
				this.rouletteIDUI.setText(`ID: ${payload.id}`);
				break;
			case 'setWinnerNumber':
				let newSelectedNumber: number | null = null;
				if (payload.number == '00') {
					//this.selectedNumber = null;
				} else {
					newSelectedNumber = parseInt(payload.number, 10);
					//this.selectedNumber = newSelectedNumber;
				}
				break;
			case 'spinRoulette':
				if (payload && payload.id) {
					if (payload.id === this.rouletteID) {
						//this.roulette.startRouletteSpin();
						if (payload.number) {
							//highlightNumbers(this, this.stopRoulette.bind(this), payload.number);
						} else {
							//highlightNumbers(this, this.stopRoulette.bind(this));
						}
					}
				}
				break;
			case 'specialNumber':
				if (payload && payload.id) {
					if (payload.id === this.rouletteID) {
						if (payload.number) {
							this.numberAreaManager.setSpecialNumber(payload.number, true);
						}
					}
				}
				break;
			default:
				console.log(`Ação WebSocket não reconhecida: ${action}`);
		}
	}

	initValues() {
		this.rouletteBalanceValue = GameConfig.balaceStart;
		this.rouletteMaxBetValue = GameConfig.maxBet;
	}

	createButtons() {
		// Verificar se o número foi passado via query string
		const numberParam = getQueryParam('number');

		// MENU BUTTON
		this.rouletteController.menuButton = new SceneButton(this, 'button-menu', 'button-menu-hover', true);
		this.rouletteController.buttons.push(this.rouletteController.menuButton);
		this.rouletteController.menuButton.create(-398, -400, 0.5, 0.5, true);
		this.rouletteController.menuButton.addClickEvent(() => {
			this.rouletteController.infoButton.button.setVisible(!this.rouletteController.infoButton.button.visible);
		}, this);
		this.rouletteController.menuButton.button.setVisible(true);

		// RULES BUTTONS
		this.rouletteController.infoButton = new SceneButton(this, 'button-info', 'button-info-hover', false);
		this.rouletteController.buttons.push(this.rouletteController.infoButton);
		this.rouletteController.infoButton.create(-335, -400, 0.5, 0.5);
		this.rouletteController.infoButton.addClickEvent(() => {
			this.guiController.showPopUp(this.createInfoPUHandler);
		}, this);
		this.rouletteController.infoButton.button.setVisible(false);

		// BUTTON DELETE
		this.rouletteController.deleteButton = new SceneButton(this, 'button-delete', 'button-delete-hover', false);
		this.rouletteController.buttons.push(this.rouletteController.deleteButton);
		this.rouletteController.deleteButton.create(468, 84, 0.5, 0.5, true);
		this.rouletteController.deleteButton.addClickEvent(() => {
			this.resetManager.resetAllBets();
		}, this);
		this.rouletteController.deleteButton.button.setVisible(true);

		// BUTTON UNDO
		this.rouletteController.undoButton = new SceneButton(this, 'button-undo', 'button-undo-hover', false);
		this.rouletteController.buttons.push(this.rouletteController.undoButton);
		this.rouletteController.undoButton.create(468, 24, 0.5, 0.5, true);
		this.rouletteController.undoButton.addClickEvent(() => {
			undoLastBet(this, this.betManager, this.chipManager);
		}, this);
		this.rouletteController.undoButton.button.setVisible(true);

		// BUTTON SPIN
		this.rouletteController.spinButton = new SceneButton(this, 'button-spin', 'button-spin-hover', false);
		this.rouletteController.buttons.push(this.rouletteController.spinButton);
		this.rouletteController.spinButton.create(468, -35, 0.5, 0.5, true);
		this.rouletteController.spinButton.addClickEvent(() => {
			if (this.inProgress === false) {
				this.chipManager.unSelectAllChips();
				// Buttons state ---
				this.rouletteController.spinButton.setInteractable(false);
				this.rouletteController.spinButton.setPressed(false);
				this.rouletteController.undoButton.setInteractable(false);
				this.rouletteController.undoButton.setPressed(false);
				this.rouletteController.deleteButton.setInteractable(false);
				this.rouletteController.deleteButton.setPressed(false);
				// Buttons state ---

				this.previousBalanceBeforeSpin = this.rouletteBalanceValue;
				this.numberAreaManager.hideHighlight();
				const ran = numberParam ? parseInt(numberParam, 10) : this.roulette.randomIntFromInterval(0, 36);
				const rot = GameConfig.numang.filter(it => {
					return it.n === ran;
				})[0];
				const rrr = this.roulette.toDegrees(rot.a - this.pr);
				this.pr = rot.a;
				let st = setTimeout(() => {
					clearTimeout(st);
					this.inProgress = true;
					this.roulette.startRouletteSpin(1080 + rrr, ran, () => {
						this.numberAreaManager.showHighlight(ran);
						const result = ran;
						const totalWin = this.betManager.resolveAndApplyWinnings(result);
						if (totalWin > 0) {
							this.rouletteBalanceValue += totalWin;
							this.rouletteBalance.setText(`Balance: ${this.rouletteBalanceValue}`);
							this.notificationManager.addNotification(`Você ganhou ${totalWin} fichas!`);
							this.score += totalWin;
							this.rouletteScore.setText(`Score: ${this.score}`);
						} else {
							this.rouletteBalance.setText(`Balance: ${this.rouletteBalanceValue}`);
						}
						// Buttons ---
						this.rouletteController.spinButton.setInteractable(true);
						this.rouletteController.spinButton.release(true);
						this.rouletteController.undoButton.setInteractable(true);
						this.rouletteController.undoButton.release(true);
						this.rouletteController.deleteButton.setInteractable(true);
						this.rouletteController.deleteButton.release(true);
						// Check Chips availabled
						this.chipManager.updateAvailableChips();
						// Clear bets ---
						this.betManager.clearBets(false);
						// Clear chips ---
						// Remover todas as fichas colocadas no mapa com efeito de fade out
						this.placedChipsMap.forEach((chipContainer, number) => {
							if (chipContainer) {
								// Aplica o efeito de fade out nas fichas antes de removê-las
								this.tweens.add({
									targets: chipContainer,
									alpha: 0, // Efeito de fade out
									duration: 500, // Duração do fade out
									onComplete: () => {
										// Após o fade out, destruir o container da ficha
										chipContainer.destroy();
									}
								});
							}
						});
						// Limpa o mapa de fichas colocadas após remover todas
						this.placedChipsMap.clear();
						// ---------------
						this.inProgress = false;
						// Check
						if (this.rouletteBalanceValue === 0) {
							this.inProgress = true;
							this.rouletteController.spinButton.setInteractable(false);
							this.rouletteController.spinButton.setPressed(false);
							this.rouletteController.undoButton.setInteractable(false);
							this.rouletteController.undoButton.setPressed(false);
							this.rouletteController.deleteButton.setInteractable(false);
							this.rouletteController.deleteButton.setPressed(false);
							this.stateController.changeState(this.gameOverState);
						}
						// Add history
						this.historyManager.addNumber(result);
					});
				}, 700);
			}
		}, this);
		this.rouletteController.spinButton.button.setVisible(true);
	}

	createUI() {
		const containerUI = this.add.container(this.centerX - 70, 345);
		const table = this.add.image(0, 0, 'rouletteTable').setOrigin(0.5, 0.5).setScale(0.8);
		const tableShadow = this.add.image(10, 10, 'rouletteTable').setOrigin(0.5).setTint(0x000000).setAlpha(0.3).setScale(0.8);
		const nyxlogo = this.add.image(230, 215, 'nyxLogo').setOrigin(0.5);
		const nyxlogoShadow = this.add.image(233, 218, 'nyxLogo').setOrigin(0.5).setTint(0x000000).setAlpha(0.3);

		const newPosY = 10;

		// ID of roulette
		this.rouletteIDUI = this.add
			.text(this.centerX - 400, this.centerY + 158, 'ID: Aguardando...', {
				font: '10px',
				color: '#ffffff'
			})
			.setOrigin(0.5);

		// Score of roulette
		this.rouletteScore = this.add.text(this.centerX - 280, 130 + newPosY, `Score: ${this.score}`, {
			color: '#ffffff'
		});
		// Balance of roulette
		this.rouletteBalance = this.add.text(this.centerX - 280, 150 + newPosY, `Balance: ${this.rouletteBalanceValue}`, {
			color: '#ffffff'
		});
		// Bet of roulette
		this.rouletteBet = this.add.text(this.centerX - 280, 170 + newPosY, `Bet: ${this.rouletteBetValue}`, {
			color: '#ffffff'
		});
		// MaxBet of roulette
		this.rouletteMaxBet = this.add.text(this.centerX - 280, 110 + newPosY, `Max Bet: ${this.rouletteMaxBetValue}`, {
			color: '#ffffff'
		});

		if (this.rouletteScore && this.rouletteScore.preFX) {
			this.rouletteScore.preFX.setPadding(32);
			this.rouletteScore.preFX.addShadow(0, 0, 0.06, 1, 0x000000, 2, 0.8);
		} else {
			console.error('preFX ou text não está disponível');
		}

		if (this.rouletteBalance && this.rouletteBalance.preFX) {
			this.rouletteBalance.preFX.setPadding(32);
			this.rouletteBalance.preFX.addShadow(0, 0, 0.06, 1, 0x000000, 2, 0.8);
		} else {
			console.error('preFX ou text não está disponível');
		}

		if (this.rouletteBet && this.rouletteBet.preFX) {
			this.rouletteBet.preFX.setPadding(32);
			this.rouletteBet.preFX.addShadow(0, 0, 0.06, 1, 0x000000, 2, 0.8);
		} else {
			console.error('preFX ou text não está disponível');
		}

		if (this.rouletteMaxBet && this.rouletteMaxBet.preFX) {
			this.rouletteMaxBet.preFX.setPadding(32);
			this.rouletteMaxBet.preFX.addShadow(0, 0, 0.06, 1, 0x000000, 2, 0.8);
		} else {
			console.error('preFX ou text não está disponível');
		}

		containerUI.add([tableShadow, table, nyxlogoShadow, nyxlogo]);
	}

	startWebsocket() {
		// WEBSOCKET -------
		const wsManager = WebSocketManager.getInstance('ws://localhost:8888/websocket');
		// Escutar o evento de conexão
		wsManager.on('connected', () => {
			console.log('Conexão WebSocket estabelecida na cena.');
		});

		// Escutar o evento de fechamento do WebSocket
		wsManager.on('closed', () => {
			console.log('Conexão WebSocket fechada.');
		});

		// Escutar o evento de erro do WebSocket
		wsManager.on('error', error => {
			console.error('Erro no WebSocket:', error);
		});

		// Escutar ações do WebSocket
		wsManager.on('websocketAction', (action, payload) => {
			this.handleWebSocketAction(action, payload);
		});
		// -----------------
	}

	startClasses() {
		this.stateController = new StateController();
		const chipData: ChipInfo[] = [
			{ value: 1, quantity: 1, color: 'orange' },
			{ value: 5, quantity: 1, color: 'black' },
			{ value: 10, quantity: 1, color: 'blue' },
			{ value: 25, quantity: 1, color: 'gray' },
			{ value: 50, quantity: 1, color: 'green' },
			{ value: 100, quantity: 1, color: 'pink' },
			{ value: 250, quantity: 1, color: 'purple' },
			{ value: 500, quantity: 1, color: 'yellow' }
		];
		this.guiController = new GuiController(this);
		this.rouletteController = new RouletteController(this);
		this.betManager = new BetManager(this);
		this.chipManager = new ChipManager(this, this.centerX - 80, 145, this.placedChipsMap, chipData, this.betManager, true);
		this.numberAreaManager = new NumberAreaManager(this, this.centerX, this.centerY, (number: string) => {
			if (!this.inProgress) {
				if (!this.betManager.checkMaximumBet() && this.rouletteBetValue < GameConfig.maxBet) {
					this.chipManager.handleNumberAreaClick(number);
				} else {
					this.notificationManager.addNotification(`Aposta maxima alcançada!`);
				}
			}
		});
		this.resetManager = new ResetManager(this, this.betManager);
		this.roulette = new Roulette(this, this.centerX - 442, 348, 152);
		this.notificationManager = new NotificationManager(this, 280, 700, 500, 15, 0xffffff, 3, '#FFFFFF', 0x000000, 0);
		// States ---
		this.iddleState = new IddleState(this, this.stateController);
		this.gameOverState = new GameOverState(this, this.stateController);
		this.stateController.initialize(this.iddleState);
	}

	trackMove(chip: Phaser.GameObjects.Container, numberArea: string) {
		//this.history.push({ chip, numberArea });
		console.log(`Tracked move: chip placed on number ${numberArea}`);
	}

	// ------
	createInfoPUHandler(popup) {
		let index = 0;
		let containers: any[] = [];
		let selectors: any[] = [];
		let offsetY = -100;

		// add background and panel
		let backGround = popup.scene.add
			.sprite(0, 0 + offsetY, 'white-background')
			.setOrigin(0.5)
			.setScale(2000);
		backGround.setInteractive(); // block bottom controls
		backGround.tint = 0x51443d;
		popup.add(backGround);

		popup.addButton('exitButton', 'exit-button', 'exit-button-hover', false, 400, -285 + offsetY);
		popup['exitButton'].clickEvent.add(() => {}, popup);
		popup['exitButton'].clickEvent.add(() => {
			popup.scene.guiController.closePopUp(popup);
		});

		// create rules panel
		let rulesContainer = popup.scene.add.container(0, 0 + offsetY);
		containers.push(rulesContainer);
		popup.add(rulesContainer);
		let rulesTitle = popup.scene.add.bitmapText(-100, -320, 'gameFont_0', 'Regras', 50, 1).setOrigin(0.5);
		rulesContainer.add(rulesTitle);

		let aboutTitle = popup.scene.add.bitmapText(-580, -140 - 85, 'gameFont_0', 'Sobre o jogo', 30, 0).setOrigin(0, 0.5); // text
		let aboutText = popup.scene.add
			.bitmapText(
				-580,
				-100 - 85,
				'gameFont_0',
				'A roleta de cassino e um jogo que usa uma roda com 37 ou 38 segmentos numerados (1 a 36 e um ou dois zeros).\n' +
					'O crupie gira a roda e lanca uma esfera sobre sua borda; quando a esfera perde velocidade, ela cai em um\n' +
					'dos compartimentos numerados. Os jogadores fazem apostas em numeros simples, grupos de numeros (colunas ou duzias),\n' +
					'cores (vermelho ou preto) ou outras combinações, colocando fichas na area correspondente do tapete.\n' +
					'Depois que a esfera para, o resultado determina os vencedores, que recebem pagamentos conforme as probabilidades \n' +
					'de cada aposta. O jogo oferece atmosfera sofisticada, ritmo agil e varias opcoes de palpite.',
				24,
				0
			)
			.setOrigin(0, 0); // text
		rulesContainer.add([aboutTitle, aboutText]);

		let howTitle = popup.scene.add.bitmapText(-580, 0, 'gameFont_0', 'Como jogar?', 30, 0).setOrigin(0, 0.5); // text
		let howText = popup.scene.add
			.bitmapText(
				-580,
				40,
				'gameFont_0',
				'- Examine o tapete de apostas, que mostra números (1 a 36), cores (vermelho/preto) e combinacoes (duzia, coluna etc.) \n' +
					'- Clique sobre o numero, cor ou combinacao de sua preferencia para posicionar cada ficha. \n' +
					'- Inicie a rodada pressionando o botão de “SPIN” ou aguarde o giro automatico',
				24,
				0
			)
			.setOrigin(0, 0); // text
		rulesContainer.add([howTitle, howText]);
	}

	createGameMessagePUHandlerShare(popup) {
		// add background and panel
		let backGround = popup.scene.add.sprite(0, 0, 'background').setOrigin(0.5).setScale(300);
		backGround.setInteractive(); // block bottom controls
		popup.add(backGround);

		// add caption
		popup.captionText = popup.scene.add.bitmapText(0, -160, 'gameFont_0', 'Caption', 38, 1).setOrigin(0.5);
		popup.captionText.tint = 0xffffff;
		popup.add(popup.captionText);

		// add message
		popup.messageText = popup.scene.add.bitmapText(0, -118, 'gameFont_0', 'Message', 28, 1).setOrigin(0.5);
		popup.messageText.tint = 0xffffff;
		popup.add(popup.messageText);

		// add message
		popup.pointsText = popup.scene.add.bitmapText(0, -80, 'gameFont_0', 'Pontos', 28, 1).setOrigin(0.5);
		popup.pointsText.tint = 0xffffff;
		popup.add(popup.pointsText);

		// add whatsapp button
		popup.addButton('whatsappButton', 'button-whatsapp', 'button-whatsapp', false, -100, 8);
		popup['whatsappButton'].clickEvent.add(() => {
			popup.scene.share('whatsapp');
		}, popup);

		// add facebook button
		popup.addButton('facebookButton', 'button-facebook', 'button-facebook', false, 0, 8);
		popup['facebookButton'].clickEvent.add(() => {
			popup.scene.share('facebook');
		}, popup);

		// add twitter button
		popup.addButton('twitterButton', 'button-twitter', 'button-twitter', false, 100, 8);
		popup['twitterButton'].clickEvent.add(() => {
			popup.scene.share('twitter');
		}, popup);

		// add buttons
		popup.addButton('exitButton', 'exit-button', 'exit-button-hover', false, 245, -175);
		popup['exitButton'].clickEvent.add(() => {}, popup);
	}
	// ------

	share(action) {
		var loc = location.href;
		loc = loc.substring(0, loc.lastIndexOf('/') + 1);

		var title = '';
		var text = '';

		var shareTitle = 'Highscore on Roulette Game at [SCORE].';
		var shareMessage = '[SCORE] is mine new highscore on Roulette Game! Try it now!';

		title = shareTitle.replace('[SCORE]', `${this.score}`);
		text = shareMessage.replace('[SCORE]', `${this.score}`);

		var shareurl = '';

		if (action == 'twitter') {
			shareurl = 'https://twitter.com/intent/tweet?url=' + loc + '&text=' + text;
		} else if (action == 'facebook') {
			shareurl =
				'https://www.facebook.com/sharer/sharer.php?u=' +
				encodeURIComponent(
					loc + 'share.php?desc=' + text + '&title=' + title + '&url=' + loc + '&thumb=' + loc + 'share.jpg&width=590&height=300'
				);
		} else if (action == 'whatsapp') {
			shareurl = 'whatsapp://send?text=' + encodeURIComponent(text) + ' - ' + encodeURIComponent(loc);
		}

		window.open(shareurl);
	}
}
